@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [autohide]="false"
    [animation]="true"
    (hidden)="toastService.closeToast(toast)"
    class="mb-2"
  >
    <ng-template ngbToastHeader>
      <div class="d-inline-flex me-auto home-ico-clr-red">
        <i
          class="fa fa-exclamation-circle home-ico-clr-red py-1 pe-2"
          aria-hidden="true"
        ></i>
        <span>{{ toast.title }}</span>
      </div>
    </ng-template>
    <div class="mx-4">{{ toast.desc }}</div>
    @if (toast.addlText) {
      <div class="mx-4 mt-2">{{ toast.addlText }}</div>
    }
  </ngb-toast>
}
